import { gql } from '@apollo/client';

export interface GetActiveSubscriptionHistoriesCountVariables {
    where: {
        school: {
            id: {
                equals: string;
            };
        };
        expiryDate: {
            gt: string;
        };
    };
}

export interface GetSubscriptionHistoriesCountResponse {
    subscriptionHistoriesCount: number;
}

export const GET_SUBSCRIPTION_HISTORIES_COUNT = gql`
    query SubscriptionHistoriesCount($where: SubscriptionHistoryWhereInput!) {
        subscriptionHistoriesCount(where: $where)
    }
`;
